import siteConfig from "../../resources/data/config"
import "./TextSignup.css"
import textIcon from '../../resources/assets/text-icon.png'

const isDesktop = window.matchMedia(
    "(hover: hover) and (pointer: fine)"
  ).matches;

function TextSignup({ buttonText }) {
    if(isDesktop) {
        return
    }
    const messageBody = encodeURIComponent("Hi Jannine,\nI'd like to signup to recieve text notifications for specials!")
    return <div className="text-signup-container">
            <a className="text-signup-button" href={`sms:+1${siteConfig.contactPhone}?body=${messageBody}`}>
                <p>
                    {buttonText}
                </p>
                <img src={textIcon} alt="text icon"></img>
            </a>
        </div>
}

export default TextSignup